<template>
  <div><div class="thank-you-container">

    <div class="ty__iamge">
    <img src="https://res.cloudinary.com/ncsy/image/upload/v1785078208/Container_zuxgqk.png" alt="NCSY Logo" class="thank-you-logo" />
    </div>
    <div class="ty__social">
      <a class="ty__social-link" href="mailto:?subject=Support%20NCSY&body=Support%20NCSY%3A%20https%3A%2F%2Fncsy.org%2Fdonate%2F" aria-label="Share via email" target="_blank" rel="noopener noreferrer">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 2v.4l8 5 8-5V6H4Zm16 12V8.5l-8 5-8-5V18h16Z" fill="#fff"/></svg>
      </a>
      <a class="ty__social-link" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fncsy.org%2Fdonate%2F" aria-label="Share on Facebook" target="_blank" rel="noopener noreferrer">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 8.5V6.8c0-.7.5-.9.8-.9H16V3.3h-2.1C11 3.3 10.4 5.4 10.4 6.7v1.8H8.7v2.8h1.7V21h3.6v-9.7h2.4l.3-2.8H14Z" fill="#fff"/></svg>
      </a>
      <button type="button" class="ty__social-link" aria-label="Share on Instagram" @click="shareInstagram">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.3A4.7 4.7 0 1 0 12 16.7 4.7 4.7 0 0 0 12 7.3Zm0 7.7a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm4.9-7.9a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0ZM20 6.9a5.4 5.4 0 0 0-1.5-3.8A5.4 5.4 0 0 0 14.7 1.6c-1.5-.1-6-.1-7.5 0A5.4 5.4 0 0 0 3.5 3.1 5.4 5.4 0 0 0 2 6.9c-.1 1.5-.1 6 0 7.5a5.4 5.4 0 0 0 1.5 3.8 5.4 5.4 0 0 0 3.8 1.5c1.5.1 6 .1 7.5 0a5.4 5.4 0 0 0 3.8-1.5 5.4 5.4 0 0 0 1.5-3.8c.1-1.5.1-6 0-7.5Zm-2 9.1a3 3 0 0 1-1.7 1.7c-1.2.5-4 .4-5.3.4s-4.1.1-5.3-.4A3 3 0 0 1 6 16c-.5-1.2-.4-4-.4-5.3S5.5 6.6 6 5.4A3 3 0 0 1 7.7 3.7c1.2-.5 4-.4 5.3-.4s4.1-.1 5.3.4A3 3 0 0 1 20 5.4c.5 1.2.4 4 .4 5.3s.1 4.1-.4 5.3Z" fill="#fff"/></svg>
      </button>
      <a class="ty__social-link" href="https://twitter.com/intent/tweet?text=Support%20NCSY&url=https%3A%2F%2Fncsy.org%2Fdonate%2F" aria-label="Share on X" target="_blank" rel="noopener noreferrer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2 2.5h3.3l-7.2 8.2 8.5 11.3h-6.6l-5.2-6.8-6 6.8H1.7l7.7-8.8L1.2 2.5h6.8l4.7 6.2 5.5-6.2Zm-1.2 17.8h1.8L7 4.4H5.1L17 20.3Z" fill="#fff"/></svg>
      </a>
      <a class="ty__social-link" href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fncsy.org%2Fdonate%2F" aria-label="Share on LinkedIn" target="_blank" rel="noopener noreferrer">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.9 8.4H3.6V21h3.3V8.4Zm.2-3.7a1.9 1.9 0 1 0-3.8 0 1.9 1.9 0 0 0 3.8 0ZM20.4 21v-6.9c0-3.3-1.8-4.9-4.1-4.9-1.9 0-2.7 1-3.2 1.8V8.4H9.8V21h3.3v-6.6c0-1.5.3-2.9 2.1-2.9s1.8 1.7 1.8 3V21h3.4Z" fill="#fff"/></svg>
      </a>
      <button type="button" class="ty__social-link" aria-label="Copy donation link" @click="copyLink">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6 13.4a3.7 3.7 0 0 0 5.6.4l2.4-2.4a3.7 3.7 0 0 0-5.3-5.3l-1.4 1.4" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.4 10.6a3.7 3.7 0 0 0-5.6-.4l-2.4 2.4a3.7 3.7 0 0 0 5.3 5.3l1.4-1.4" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>

  </div></div>

</template>
<script setup lang="ts">
defineProps<{
  message?: string
}>()

const shareUrl = 'https://ncsy.org/donate/'

async function copyLink() {
  if (!navigator.clipboard || !window.isSecureContext) return
  try {
    await navigator.clipboard.writeText(shareUrl)
  } catch {
    // ignore
  }
}

async function shareInstagram() {
  // Instagram has no web share-by-URL intent; use the native share sheet where
  // available so the user can pick Instagram, otherwise copy the link to paste.
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title: 'Support NCSY', url: shareUrl })
      return
    } catch {
      // user cancelled or unsupported – fall through to copy
    }
  }
  await copyLink()
}
</script>
<style scoped>
.thank-you-container {
    padding: 0px;
    text-align: center;
    min-height: 300px;
   
    background: white;
    max-width: 645px;
    font-weight: 700;
    margin: auto;
    width: 100%;
   
}
.ty__social {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 20px;
}
.ty__social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #1c1c1c;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: background 0.3s ease-in-out, transform 0.2s ease-in-out;
}
.ty__social-link:hover {
    background: #f87507;
    transform: translateY(-2px);
}
.thank-you-logo{
      max-width: 100%;
    margin: auto;
}
</style>
